import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getDefaultSettings() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/settings", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching settings"
                    });
                }
            });
    },
    saveDefaultSettings(settings) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/settings", settings).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    }


}
